import { ShimmerEffect } from "@/design-system/Atoms";

const VideoSectionShimmer = () => {
    return (
        <>
            <ShimmerEffect className="h-[40px] w-[280px] mb-6" />

            <div className="form-bg bg-[#f6f7f9] mb-10 p-8 rounded-[20px]">
                <ShimmerEffect className="h-[20px] w-[85%] mb-4" />

                <div className="bg-white p-[1.25rem] mb-6 rounded-[8px]">
                    <div className="flex items-center justify-between gap-4">
                        <ShimmerEffect className="h-[28px] w-[70%]" />
                        <ShimmerEffect className="h-[48px] w-[120px] rounded-lg" />
                    </div>
                </div>

                <div className="bg-white p-[1.25rem] mb-6 rounded-[8px]">
                    <div className="flex items-center justify-between gap-4">
                        <ShimmerEffect className="h-[28px] w-[65%]" />
                        <ShimmerEffect className="h-[48px] w-[120px] rounded-lg" />
                    </div>
                </div>

                <div className="bg-white p-[1.25rem] mb-6 rounded-[8px]">
                    <div className="flex items-center justify-between gap-4">
                        <ShimmerEffect className="h-[28px] w-[75%]" />
                        <ShimmerEffect className="h-[48px] w-[120px] rounded-lg" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default VideoSectionShimmer;